import Api from "../api/api";

export default async (body) => {
  const { data } = await Api.post("news_letter", body);
  return data;
};
